/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:efc0c410-5ba9-4338-988c-ecfe59036dbb",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_Pj6RXB1Ns",
    "aws_user_pools_web_client_id": "128qjev5dm5a2e90gnuanmnp5c",
    "oauth": {},
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "lwart-sequence-prd",
            "region": "us-east-1"
        },
        {
            "tableName": "lwart-coleta-prd",
            "region": "us-east-1"
        },
        {
            "tableName": "lwart-pesquisa-prd",
            "region": "us-east-1"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "PesquisaAPI",
            "endpoint": "https://bqwu11x2y9.execute-api.us-east-1.amazonaws.com/prd",
            "region": "us-east-1"
        },
        {
            "name": "ColetaAPI",
            "endpoint": "https://ovdr8j4g2d.execute-api.us-east-1.amazonaws.com/prd",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
